import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { MailCheck, Waypoints } from "lucide-react";
import api, { apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function CustomerLogin() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/magic-link", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6" data-testid="customer-login-page">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-2 mb-10" data-testid="customer-login-logo">
          <Waypoints className="h-5 w-5" />
          <span className="font-heading font-bold">CreateForms.app</span>
        </Link>
        {sent ? (
          <div data-testid="magic-link-sent">
            <MailCheck className="h-12 w-12 text-emerald-600" />
            <h1 className="mt-6 text-3xl font-black">Check your inbox</h1>
            <p className="mt-3 text-sm text-neutral-500 leading-relaxed">
              If <b>{email}</b> has submissions on our system, we've sent a one-time login link. It expires in 24 hours.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-6">
            <div>
              <h1 className="text-3xl font-black">Customer login</h1>
              <p className="text-sm text-neutral-500 mt-2">
                No password needed. Enter the email you used on a submission and we'll send you a one-time login link.
              </p>
            </div>
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-14 text-lg" data-testid="customer-email-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full rounded-full h-12" data-testid="customer-login-submit">
              {loading ? "Sending…" : "Email me a login link"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
